<script>
import { mapActions } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';
import { newMembers, followNewUser } from '../../api/new-members';
import { startChat } from '../../api/chat';

export default {
  name: 'CpSocialFeedNewMemberPost',
  components: {
    CpImage: require('../../image').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpButtonLink: require('../../button-link').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    NewMemberAddIcon: require('../icons/new-member-add').default,
    ChatIcon: require('../icons/chat').default,
    VueSimpleSpinner: require('../../vue-simple-spinner').default,
    CpTagIcon: require('../../tags/icon').default,
    CpButton: require('../../button').default,
    MemberAnonymousIcon: require('../icons/member-anonymous').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpChatButton: require('../../components/ChatButton').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  data() {
    return {
      indexFollowNewMember: [],
      loadingChatIndex: undefined,
      loadingFollowMemberIndex: undefined,
      showAuthModal: false,
      isLoginCallbackActive: false,
    };
  },
  props: {
    newMember: Object,
    user: Object,
  },
  methods: {
      profile(slug) {
          return '/profile/' + slug;
      },
      followNewUser() {
        this.loadingFollowMemberIndex = this.newMember.id;
        if (!this.authUser) {
          this.showAuthModal = true;
        } else {
            this.handleFollowNewUser();
        }
      },
      handleFollowNewUser() {
        followNewUser(this.newMember.id)
          .then(async (response) => {
              this.indexFollowNewMember.push(this.newMember.id);
              this.loadingFollowMemberIndex = undefined;
              await this.handleChatEnabled(this.newMember.id);
          })
          .catch((error) => {
              console.warn(error);
              this.loadingFollowMemberIndex = undefined;
          });
      },
      handleCloseButton() {
        this.showAuthModal = false;
        const isSocialLogin = window.sessionStorage.getItem('openWindowForSocialLogin');
        if (!this.isLoginCallbackActive && !isSocialLogin) {
          this.loadingChatIndex = undefined;
          this.loadingFollowMemberIndex = undefined;
        }
      },
      loginCallbackAction() {
        this.isLoginCallbackActive = true;
        if (this.loadingChatIndex) {
          this.handleStartChat();
          this.loadingChatIndex = undefined;
        } else {
          this.handleFollowNewUser();
          this.loadingFollowMemberIndex = undefined;
        }
        this.isLoginCallbackActive = false;
      },
      handleStartChat() {
        this.loadingChatIndex = this.newMember.id;
        if (!this.authUser) {
          this.showAuthModal = true;
        } else {
          startChat(this.loadingChatIndex, this.newMember, this.authUser);
        }
      },
      ...mapActions(useUserStore, ['handleChatEnabled']),
  },
  computed: {
      authUser() {
          return this.$root.authUser;
      },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="newMember.last_follower">
      <CpCardHeaderReactions :post="newMember.last_follower" />
    </div> -->
    <div class="card-content-container">
      <a :href="newMember.permalink" class="image-container" v-margin-right=".5">
        <cp-image
          :src="$root.isMobile ? newMember.image_feed_mobile : newMember.image_feed"
          alt="Profile image"
          width="100%"
          circular
        />
      </a>
      <div class="info-container">
        <p v-if="!newMember.last_follower" class="footnote neutral4-color" v-margin="0">New Member</p>
        <span><a :href="newMember.permalink" v-if="newMember.fullname" class="subheadline1 primary-color" v-margin-top="0">{{ newMember.fullname }}</a></span>
        <div v-if="newMember.tags.length > 0" class="tags-container">
          <span v-for="(tag) in newMember.tags" :key="tag.name" class="tag">
            <cp-tag-icon iconOnly :tag="tag.name" :height="16" :width="16" />
            <p class="caption neutral4-color" v-margin="0" v-margin-left=".2">{{ tag.name }}</p>
          </span>
        </div>
        <div v-if="!$root.isMobile" class="buttons-new-members">
          <span
            v-if="!indexFollowNewMember.includes(newMember.id) && loadingFollowMemberIndex !== newMember.id && newMember.follow != 'following'"
            class="btn-new-member caption1 primary-color cursor-pointer"
            @click.prevent="followNewUser"
          >
            Follow
          </span>
          <vue-simple-spinner
            v-else-if="!indexFollowNewMember.includes(newMember.id) && loadingFollowMemberIndex === newMember.id"
            :size="20"
          />
          <h3 v-else class="btn-new-member caption1 primary-color">Following</h3>
          <vue-simple-spinner v-if="loadingChatIndex === newMember.id" :size="20" />
          <CpChatButton v-else :otherUserId="newMember.id" :callback="handleStartChat" :loading="loadingChatIndex" />
        </div>
      </div>
    </div>
    <div v-if="$root.isMobile" class="buttons-new-members">
      <span
        v-if="!indexFollowNewMember.includes(newMember.id) && loadingFollowMemberIndex !== newMember.id && newMember.follow != 'following'"
        class="btn-new-member caption1 primary-color cursor-pointer"
        @click.prevent="followNewUser"
      >
        Follow
      </span>
      <vue-simple-spinner
        v-else-if="!indexFollowNewMember.includes(newMember.id) && loadingFollowMemberIndex === newMember.id"
        :size="20"
      />
      <h3 v-else class="btn-new-member caption1 primary-color">Following</h3>
      <vue-simple-spinner v-if="loadingChatIndex === newMember.id" :size="20" />
      <CpChatButton v-else :otherUserId="newMember.id" :callback="handleStartChat" :loading="loadingChatIndex" />
    </div>
    <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="loginCallbackAction" />
  </div>
</template>

<style scoped>
a {
  text-decoration: none;
}

.card-content-container {
  display: flex;
  align-items: center;
}

.info-container {
  display: flex;
  flex-direction: column;
}

.image-container {
  width: 120px;
}

.tags-container, .tag {
  display: flex;
  align-items: center;
}

.tags-container {
  flex-wrap: wrap;
}

.tag {
  margin: 0 4px;
}

.btn-new-member {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 120px;
  margin: 0 5px;
  border-radius: 6px;
  border: 1px var(--primary) solid;
  background: var(--white);
}

.buttons-new-members {
  margin: 20px 0 0;
  display: flex;
  align-items: center;
}

.cursor-pointer {
  cursor: pointer;
}

@media only screen and (min-width: 1024px) and (max-width: 1366px) {
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
}
@media only screen and (max-width: 768px) {
  .buttons-new-members {
    justify-content: center;
  }
  .btn-new-member {
    width: 50%;
  }
}

@media only screen and (max-width: 550px) {
  .image-container {
    width: 90px;
  }
  .btn-new-member {
    width: 100%;
  }
}

@media only screen and (max-width: 400px) {
  .image-container {
    width: 60px;
  }
  .tags-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .tag {
    width: 100%;
  }
}
</style>
